export const getStyle = ({
  imageDesktop,
  imageMobile,
  fontSettings,
  layoutSettings,
  hasAdditionalContent
}) => {
  return `<style>
    .wrapper {
      max-width: 1342px;
      padding: 0 48px;
      margin: 0 auto;
    }
    .banner-container {
      background-image: url(${imageDesktop});
      display: flex;
      border-radius: 12px;
      justify-content: center;
      align-items: ${layoutSettings.desktop.verticalAlignment};
      background-size: cover;
      background-position: bottom;
      margin-top: 20px;
    }
    .banner-inner-container {
      width: 100%;
      padding: ${layoutSettings.desktop.contentPadding};
      ${
        hasAdditionalContent
          ? `display: flex;
          align-items: flex-start;
          gap: 50px;
          justify-content: space-between;
          max-width: 1342px;`
          : ''
      }
    }

    .text-block {
      padding-left: ${hasAdditionalContent ? '0' : 'min(11%, 162px)'};
      padding-right: ${hasAdditionalContent ? '0' : 'min(11%, 162px)'};
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      text-align: ${fontSettings.desktop.textAlignment}
    }
    .text-block .eyebrow {
      font-size: 16px;
      text-transform: uppercase;
      letter-spacing: 3.2px;
      line-height: 22px;
      margin: 0 0 10px 0;
    }
    .text-block .title {
      font-family: Spectral-ExtraLight, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: ${fontSettings.desktop.title.size};
      color: #262929;
      letter-spacing: -1.86px;
      font-weight: normal;
      margin: 0 0 10px 0;
      line-height: ${fontSettings.desktop.title.lineHeight};
      width: 75%;
    }
    .text-block .description {
      font-family: GT-America-Standard-Regular, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: ${fontSettings.desktop.description.size};
      line-height: ${fontSettings.desktop.description.lineHeight};
      color: #262929;
      max-width: 575px;
    }
    .wrapper.full-width {
      padding: 0;
      max-width: unset;
    }
    .wrapper.full-width .text-block .title {
      margin: 0;
      line-height: ${fontSettings.desktop.title.lineHeight};
    }
    .wrapper.full-width .banner-container {
      border-radius: 0;
      height: ${layoutSettings.desktop.bannerHeight}px;
      margin: 0;
    }
    .wrapper.full-width .text-block .description {
      width: 100%;
    }
    @media screen and (min-width: 768px) and (max-width: 1400px) {
      .text-block .title {
        width: 50%;
      }
      .wrapper.full-width .text-block .title {
        width: 100%;
      }
    }
    @media (max-width: 1080px) {
      .text-block .description {
        max-width: 300px;
      }
      .wrapper.full-width .text-block .description {
        max-width: unset;
      }
    }
    @media (max-width: 768px) {
      .wrapper {
        max-width: unset;
        padding: 0;
      }
      .banner-container {
        border-radius: 0;
        padding: 0 !important;
        background-image: url(${imageMobile});
        align-items: ${layoutSettings.mobile.verticalAlignment};
      }
      .banner-inner-container {
        padding: ${layoutSettings.mobile.contentPadding};
        ${
          hasAdditionalContent
            ? `flex-direction: column;
            gap: 35px;`
            : ''
        }
      }
      .additional-banner-content {
        width: 100%;
      }
      .text-block {
        padding: 16px 24px 160px 24px;
        text-align: ${fontSettings.mobile.textAlignment}
      }
      .text-block .title {
        font-size: ${fontSettings.mobile.title.size};
        line-height: ${fontSettings.mobile.title.lineHeight};
        letter-spacing: -.38px;
      }
      .text-block .description {
        font-size: ${fontSettings.mobile.description.size};
        line-height: ${fontSettings.mobile.description.lineHeight};
        margin-top: 8px;
        width: 100%;
      }
      .wrapper.full-width .text-block {
        padding: 10px 0;
        width: auto;
      }
      .wrapper.full-width .text-block .title {
        line-height: ${fontSettings.mobile.title.lineHeight};
        width: 100%;
      }
      .wrapper.full-width .text-block .description {
        margin-top: 0;
        max-width: unset;
      }
      .wrapper.full-width .banner-container {
        height: ${
          layoutSettings.mobile.bannerHeight
            ? `${layoutSettings.mobile.bannerHeight}px`
            : 'auto'
        };
      }
    }
  </style>`;
};

export const getCtaStyle = (ctaSettings) => {
  return `<style>
    .cta.cta-link {
      display: inline-block !important;
      border: none;
      text-decoration: none;
      margin-top: 32px;
      line-height: 32px;
      width: 300px;
      color: ${ctaSettings.fontColor};
      background: ${ctaSettings.backgroundColor};
    }
    .cta.cta-link:hover {
      background-color: ${ctaSettings.backgroundHoverColor};
      color: ${ctaSettings.fontHoverColor};
    }
    @media (max-width: 768px) {
      .cta.cta-link {
      margin-top: 25px;
      width: auto;
      min-width: 150px;
    }
  </style>`;
};
